import React from 'react';
import { Button, Container } from '../../../components';
import LoadFile from './LoadFile';
import PaymentReminderFileTable from './PaymentReminderFileTable';
import { FcCancel } from 'react-icons/fc';
import AbortMailList from './AbortMailList';
import {
  ModalProvider,
  useModal,
} from '../../../components/common/modal/ModalContext';

const PaymentReminderLoadView = () => {
  const { openModal, closeModal } = useModal();
  const handleOpenModal = () => {
    openModal(<AbortMailList closeModal={closeModal} />, 'Abort Email List');
  };

  return (
    <Container title="Upload File">
      <div className="flex justify-between mr-12 items-center">
        <LoadFile />
        <div>
          <Button className="secondary" onClick={handleOpenModal}>
            <div>
              <FcCancel />
            </div>
            <div>Abort Email</div>
          </Button>
        </div>
      </div>
      <PaymentReminderFileTable />
    </Container>
  );
};

const App = () => (
  <ModalProvider>
    <PaymentReminderLoadView />
  </ModalProvider>
);

export default App;
